import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Apostás al 1X2 porque es el único mercado que conocés — ignorando docenas de mercados con mejor value', 'No sabés calcular si una cuota tiene value positivo o estás apostando en contra del mercado', 'Hacés combinadas de 5+ equipos porque "la cuota es más grande" sin entender que la probabilidad de acertar cae al 10%', 'Perdés 3 seguidas y apostás más para "recuperar" — el patrón más destructivo en las apuestas', 'Seguís picks de grupos de Telegram sin entender el razonamiento detrás y no aprendés nada', 'No tenés registro de tus apuestas — no sabés qué mercados te funcionan y cuáles no', 'Cada fase del torneo te genera la misma pregunta: "¿qué se supone que tengo que apostar ahora?"'];
  return <section className="py-20 bg-black" data-id="element-229">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-231">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-232">
            ¿Cuántas veces más vas a apostar en el Mundial por instinto y
            terminar el torneo en negativo?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-233">
            <p className="text-[14px]" data-id="element-234">
              Querés disfrutar el Mundial y que tus apuestas tengan sentido. Tal
              vez ya probaste apostar "siguiendo el corazón" y terminaste mal.
              Tal vez seguiste picks de grupos de WhatsApp que resultaron ser
              humo. Tal vez apostaste combinadas de 6 equipos que fallaron por
              uno. Tal vez tenés la sensación de que "el que gana siempre es la
              casa" y no entendés por qué.
            </p>
            <p data-id="element-235">
              <strong className="text-white text-[16px]" data-id="element-236">
                No es mala suerte. Es que nadie te enseñó cómo funciona el
                mercado desde adentro.
              </strong>
            </p>
            <p className="text-[14px]" data-id="element-237">
              Buscás análisis en YouTube y encontrás opiniones sin metodología.
              Seguís picks de tipsters que nunca muestran sus pérdidas. Apostás
              al favorito porque "todos dicen que va a ganar" sin calcular si la
              cuota tiene value real. Y seguís llegando al final de cada jornada
              con la sensación de que "podría haberlo visto venir."
            </p>
            <p className="font-bold text-white pt-4 text-[14px]" data-id="element-238">
              No es falta de conocimiento del fútbol. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-239">
          <ul className="space-y-4" data-id="element-240">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-241">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-242">
                  <X className="w-4 h-4 text-red-400" data-id="element-243" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-244">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-245">
          <p className="font-bold text-amber-400 text-[16px]" data-id="element-246">
            ¿Y si este fuera el último Mundial que apostás sin un sistema real?
          </p>
        </div>
      </div>
    </section>;
}